export default "__VITE_ASSET__DeqXwC1$__"